// @flow

import { combineReducers } from 'redux';
import User from '../pages/user-management/userReducers';
import Customer from '../pages/customer-management/customerReducers';
import Profile from '../pages/profile/profileReducers';
import Product from '../pages/catalog-management/product/productReducers';
import Category from '../pages/catalog-management/category/categoryReducers';
import Supplier from '../pages/user-management/supplier/supplierReducers';
import Notification from '../pages/notifications/notificationReducers';
import Location from '../pages/locations/locationReducers';
import Stock from '../pages/stock-management/stock/stockReducers';
import DevSupport from '../pages/dev-support/devSupportReducers';
import Price from '../pages/price-management/priceReducers';
import Checkout from '../pages/checkout/checkoutReducers';
import Order from '../pages/order/orderReducers';
import Localization from '../pages/localization/localizationReducers';
import Lead from '../pages/lead-management/leadReducers';
import Invoice from '../pages/invoice/invoiceReducers';
import Quote from '../pages/quote/quoteReducers';
import Setting from '../pages/setting/settingReducers';
import CalendarEvent from '../pages/calendar-event/calendarEventReducers';
import Discount from '../pages/discount-management/discountReducers';
import Signature from '../../_metronic/helpers/digital-signature/signatureReducers';
import VerandaCalculator from '../pages/veranda-calculator/verandaCalculatorReducers';
import {Production} from '../pages/production/productionReducers';

export default combineReducers({
    User,
    Customer,
    Profile,
    Product,
    Category,
    Supplier,
    Notification,
    Location,
    Stock,
    DevSupport,
    Price,
    Checkout,
    Order,
    Localization,
    Lead,
    Invoice,
    Quote,
    Setting,
    CalendarEvent,
    Discount,
    Signature,
    VerandaCalculator,
    Production
});
